const ccUnitMap = {
  admin_scitech: {
    name: "과학기술대학",
    headerName: "과학기술대학 학생회",
    collegeId: 1,
  },
  admin_global: {
    name: "글로벌융합대학",
    headerName: "글로벌융합대학 학생회",
    collegeId: 2,
  },
  admin_future: {
    name: "미래인재대학",
    headerName: "미래인재대학 학생회",
    collegeId: 3,
  },
  admin_pharm: {
    name: "약학대학",
    headerName: "약학대학 학생회",
    collegeId: 4,
  },
  admin_artdesign: {
    name: "아트앤디자인대학",
    headerName: "아트앤디자인대학 학생회",
    collegeId: 5,
  },
  admin_club: {
    name: "동아리연합회",
    headerName: "동아리연합회",
    collegeId: 6,
  },
};

const ccUnitByCollegeId = {
  1: ccUnitMap.admin_scitech,
  2: ccUnitMap.admin_global,
  3: ccUnitMap.admin_future,
  4: ccUnitMap.admin_pharm,
  5: ccUnitMap.admin_artdesign,
  6: ccUnitMap.admin_club,
};

const auditUnit = {
  name: "감사위원회",
  headerName: "감사위원회",
  collegeId: null,
};

const isAuditAdmin = ({ adminType, adminId, role, userName }) => {
  const normalizedAdminType = String(adminType || "").toLowerCase();
  const normalizedAdminId = String(adminId || "").toLowerCase();
  const normalizedRole = String(role || "").toUpperCase();
  const normalizedUserName = String(userName || "");

  return (
    normalizedAdminType === "audit" ||
    normalizedRole === "AUDIT" ||
    normalizedRole === "AUDITOR" ||
    normalizedAdminId === "admin_audit" ||
    normalizedAdminId.includes("audit") ||
    normalizedUserName.includes("감사위원회")
  );
};

export const getStoredAdminInfo = () => {
  const adminType = localStorage.getItem("adminType");
  const adminId = localStorage.getItem("adminId") || "";
  const role = localStorage.getItem("role") || "";
  const userName = localStorage.getItem("userName") || "";

  const storedCollegeId = Number(localStorage.getItem("collegeId"));

  const isAudit = isAuditAdmin({
    adminType,
    adminId,
    role,
    userName,
  });

  const isStdCouncil = adminType === "stdcouncil" && !isAudit;
  const isCc = adminType === "cc" && !isAudit;

  const unit = isAudit
    ? auditUnit
    : ccUnitByCollegeId[storedCollegeId] || ccUnitMap[adminId] || null;

  return {
    adminType,
    adminId,
    role,
    userName,
    isStdCouncil,
    isCc,
    isAudit,
    unit,
    unitName: unit?.name || "관리자",
    headerName: unit?.headerName || "관리자",
    collegeId: unit?.collegeId ?? null,
  };
};

export const getAdminHomePath = () => {
  const adminType = localStorage.getItem("adminType");
  const adminId = localStorage.getItem("adminId") || "";
  const role = localStorage.getItem("role") || "";
  const userName = localStorage.getItem("userName") || "";

  const isAudit = isAuditAdmin({
    adminType,
    adminId,
    role,
    userName,
  });

  if (isAudit) {
    return "/stdcounciladmin/adminhome/data/audit-committee";
  }

  if (adminType === "stdcouncil") {
    return "/stdcounciladmin/adminhome/intro/intro/current/student";
  }

  if (adminType === "cc") {
    return "/stdcounciladmin/adminhome/intro";
  }

  return "/stdcounciladmin";
};

export const clearAdminStorage = () => {
  localStorage.removeItem("adminId");
  localStorage.removeItem("adminType");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("collegeId");
  localStorage.removeItem("userName");
  localStorage.removeItem("keepLogin");
};